import type { FilterKey, SlugParamKey } from '../../../Entities/Search/QueryParams.entity';
import { slugParamMapping } from '../Search.constants';

export const getSlugParamFromFilter = (filterKey: FilterKey) => {
  return Object.keys(slugParamMapping).find(key =>
    slugParamMapping[key as SlugParamKey].includes(filterKey),
  );
};
